// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"f95221b9","633":"3dc605d0","853":"286f65a1","888":"3dc605d0"}[chunkId] + ".chunk.css";
};